export default __webpack_public_path__ + "static/media/chain-poly.83d8cda4.png";